import React, { Component } from "react";
import Lottie from "react-lottie";
import animationData from "./done.json";

class UncontrolledLottie extends Component {
  render() {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    return (
      <div>
        <Lottie options={defaultOptions} height={120} width={120} />
      </div>
    );
  }
}

export default UncontrolledLottie;
